module.exports = __webpack_public_path__ + "static/media/astro_service.9d34eafe.png";